import { ImportCard } from '@euler/app/flows/apdm/imports/components/import-card';
import { useApdmImport } from '@euler/functions/apdm/import/useApdmImport';
import { canManageApdmImports } from '@euler/functions/apdmAccess';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { parseApdmImportMappingWidgetPayload } from '@euler/model/apdm/widgets';
import { Text, View } from 'react-native';
import { useTheme } from 'styled-components';

function ImportInChat({ importId }: { importId: string }) {
  const controller = useApdmImport(importId);
  return (
    <View style={{ paddingVertical: 12 }}>
      <ImportCard controller={controller} onDeleted={() => undefined} />
    </View>
  );
}

/**
 * The import the assistant started: its progress, then its summary with the
 * button that starts it. Rendering only reads; the user's taps act.
 */
export function ApdmImportMappingWidget({
  data,
  streaming = false,
}: {
  data: unknown;
  streaming?: boolean;
}) {
  const profile = useUserProfileInfo();
  const theme = useTheme();
  const refValue = parseApdmImportMappingWidgetPayload(data);
  if (!refValue)
    return (
      <Text style={{ color: theme.label.color }}>
        导入引用无效，请重新选择导入文件。
      </Text>
    );
  if (!canManageApdmImports(profile ?? null))
    return (
      <Text style={{ color: theme.label.color }}>
        当前账号无法查看这次导入。
      </Text>
    );
  if (streaming) return null;
  return (
    <ImportInChat
      key={`${profile!.user.userId}:${profile!.store.id}:${refValue.importId}`}
      importId={refValue.importId}
    />
  );
}
